
import MenuOptions from "../MenuOptions/MenuOptions.vue";
import { defineComponent } from "vue";
import firebaseConfig from "@/firebase";
import { getFirestore, getDocs, collection } from "firebase/firestore";
import { getAuth, signOut } from "firebase/auth";
const auth = getAuth();
const db: any = getFirestore();
firebaseConfig;
export default defineComponent({
  name: "AppMenu",
  components: {
    MenuOptions,
  },
  data() {
    return {
      user: {
        name: "",
        email: "",
      },
    };
  },
  computed: {
    cImage(this: any) {
      return this.$store.getters.getImg;
    },
  },
  created() {
    this.getUser();
  },
  mounted() {
    this.checkUser();
  },
  methods: {
    async getUser() {
      const querySnapshot = await getDocs(collection(db, "documents"));
      await querySnapshot.forEach((doc: any) => {
        this.validateSignIn(doc);
      });
    },
    validateSignIn(doc: any) {
      const data = doc.data();
      if (data.isSignedIn) {
        if (doc.id == "users") {
          this.user.name = data.username as string;
          this.user.email = data.email as string;
          this.$store.commit("setImg", data.img as string);
          this.$store.commit("setSignedIn", data.isSignedIn as boolean);
          this.$router.push("/dashboard");
        }
      } else {
        this.$router.push("/auth");
      }
    },
    checkUser() {
      if (this.$store.getters.getSignedIn) {
        this.getUser();
      } else {
        this.handleSignOut();
      }
    },
    handleSignOut() {
      signOut(auth)
        .then(() => {
          this.$store.commit("setUser", {});
          localStorage.setItem("username", "-");
          localStorage.setItem("email", "-");
          localStorage.setItem("img", "-");
          this.$store.commit("setSignedIn", false);
          this.$router.push("/auth");
        })
        .catch((error) => {
          console.log(error);
          this.$router.push("/auth");
        });
    },
  },
});
